var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SJFW-container"},[_vm._m(0),_c('ViewContentVue',{attrs:{"list":_vm.data1}}),_c('ViewContentVue',{attrs:{"list":_vm.data2}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BigImg"},[_c('p',[_vm._v("数据服务")]),_c('a',{attrs:{"href":"#bottom"}},[_vm._v("咨询合作")])])
}]

export { render, staticRenderFns }